// ⚠️⚠️⚠️⚠️ AUTO GENERATED FILE ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from '../../schema';

import gql from '@workspace/graphql-codegen-fetch';
export type UpdateMyDefaultCurrencyMutationVariables = Exact<{
  currency: string;
}>;


export type UpdateMyDefaultCurrencyMutation = { featuresToggleCurrency: { isTagEnabled: boolean | undefined, features: { id: string, walletCurrency: string | undefined } | undefined, errors: Array<{ message: string | undefined, code: number | undefined, params: Array<{ name: string | undefined, value: string | undefined } | undefined> | undefined } | undefined> | undefined } | undefined };


export const UpdateMyDefaultCurrencyMutationDocument = gql`
    mutation UpdateMyDefaultCurrencyMutation($currency: String!) {
  featuresToggleCurrency(input: { currency: $currency }) {
    isTagEnabled
    features {
      id
      walletCurrency: myGroupTag(name: "DepositCurrency")
    }
    errors {
      message
      code
      params {
        name
        value
      }
    }
  }
}
    `;